import React from "react";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import CouponsHeading from "components/Coupons/CouponsHeading";
import CityWiseList from "components/Coupons/CityWiseList";
import ChargingNetworkWiseList from "components/Coupons/ChargingNetworkWiseList";
import ConfirmDeleteCoupanCity from "components/Coupons/ConformDeleteCoupanCity";
import ConfirmDeleteCharingNetwork from "components/Coupons/ConformDeleteChargingNetworkWise";
import { Grid } from "@mui/material";
import { CoupanCityApi } from "stores/CoupanCitylistStore/CoupanCityApi";

class CouponsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      deleteCityOpen: false,
      cityCopen_id: "",
      Network_id: "",
      deleteNetworkOpen: false,
    };

    this.handleTabChange = this.handleTabChange.bind(this);
  }

  componentDidMount() {
    this.props.getCoupanCityActions();
    this.props.getChargingNetworkWiseActions();
  }

  handleDeleteCoupanClick = (id) => {
    this.setState({ cityCopen_id: id });
    this.setState({ deleteCityOpen: true });
  };
  handleDeleteNetworkClick = (id) => {
    this.setState({ Network_id: id });
    this.setState({ deleteNetworkOpen: true });
  };

  handleTabChange(e, newValue) {
    this.setState({ value: newValue });
  }

  handleCloseCoupanConform = () => {
    this.setState({ deleteCityOpen: false });
  };
  handleCloseNetworkConform = () => {
    this.setState({ deleteNetworkOpen: false });
  };

  handleDeleteCoupanConform = async () => {
    await CoupanCityApi.getCoupanCityDeleteApi({ id: this.state.cityCopen_id });

    await this.props.getCoupanCityActions();
    this.setState({ deleteCityOpen: false });
  };

  handleDeleteNetworkConform = async () => {
    await CoupanCityApi.getCoupanCityDeleteApi({ id: this.state.Network_id });
    await this.props.getChargingNetworkWiseActions();
    this.setState({ deleteNetworkOpen: false });
  };
  render() {
    const newdata = this.props.CoupanCityList?.result;
    const datawise = this.props.ChargingNetwoekList?.result;
    return (
      <>
        <Grid container>
          <Grid item xs={12} lg={12}>
            <Paper sx={{ p: 3, mt: 3.5, marginLeft: "5px", width: "72vw" }}>
              <Stack>
                <CouponsHeading />
              </Stack>
              <TabContext value={this.state.value}>
                <Box
                  sx={{ borderBottom: 1, borderColor: "divider", marginTop: 3 }}
                >
                  <Tabs
                    value={this.state.value}
                    onChange={this.handleTabChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab
                      label="City Wise"
                      sx={{ textTransform: "none" }}
                      value="1"
                      index={0}
                    />
                    <Tab
                      label="Charging Network Wise"
                      sx={{ textTransform: "none" }}
                      value="2"
                      index={1}
                    />
                  </Tabs>
                </Box>
                <TabPanel value={"1"} index={0} sx={{ px: 0 }}>
                  <CityWiseList
                    loading={this.props.isloadingCoupanList}
                    onDeleteClick={(val) => this.handleDeleteCoupanClick(val)}
                    data={newdata}
                  />
                </TabPanel>
                <TabPanel value={"2"} index={1} sx={{ px: 0 }}>
                  <ChargingNetworkWiseList
                    loading={this.props.isloadingChargingn}
                    data={datawise}
                    handleDeleteNetworkClick={(val) =>
                      this.handleDeleteNetworkClick(val)
                    }
                  />
                </TabPanel>
              </TabContext>
              <ConfirmDeleteCoupanCity
                open={this.state.deleteCityOpen}
                handleClose={this.handleCloseCoupanConform}
                handleCityDelete={this.handleDeleteCoupanConform}
              />
              <ConfirmDeleteCharingNetwork
                open={this.state.deleteNetworkOpen}
                handleClose={this.handleCloseNetworkConform}
                handleNetworkDelete={this.handleDeleteNetworkConform}
              />
            </Paper>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default CouponsContainer;
